import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Undo = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 20 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12.5 19.73H3.75a1.25 1.25 0 0 1 0-2.5h8.75a3.75 3.75 0 0 0 0-7.5H5.517l2.866 2.867a1.25 1.25 0 0 1-1.767 1.767l-5-5a1.25 1.25 0 0 1 0-1.767l5-5a1.25 1.25 0 1 1 1.767 1.767L5.517 7.23H12.5a6.25 6.25 0 0 1 0 12.5z" />
    </svg>
  );
};

Undo.displayName = 'Undo';
